<!--  床位清空记录  -->
<template>
  <table-view :total="total" :query-info.sync="queryInfo" @reload-table="renderTable">
    <template #header>
      <!--   去掉学院筛选条件，否则全局的 限制教师只能按照所属学院筛选信息的问题会出现   -->
      <view-search-form ref="searchFormRef" :queryInfo.sync="queryInfo" :tool-list="['keyword']"
                        @on-search="renderTable(1)">
        <el-form-item label="宿舍楼" prop="build" label-width="55px">
          <el-select
            size="small"
            v-model="queryInfo.dormitoryId"
            clearable
            filterable
            @change="changeBuild">
            <el-option
              v-for="{dormitoryName,id} in buildList"
              :label="dormitoryName"
              :value="id"
              :key="id" />
          </el-select>
        </el-form-item>
        <el-form-item label="楼层">
          <el-select
            size="small"
            v-model="queryInfo.floorNum"
            clearable
            filterable
            @change="getDormRoomList"
            style="width: 80px;">
            <el-option
              v-for="floor in +floorList"
              :label="floor+'层'"
              :value="floor"
              :key="floor" />
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍号" prop="room" label-width="55px">
          <el-select
            size="small"
            v-model="queryInfo.roomId"
            clearable
            filterable
            @change="renderTable(1)">
            <el-option
              v-for="{roomName,id} in roomList"
              :label="roomName"
              :value="id"
              :key="id" />
          </el-select>
        </el-form-item>
      </view-search-form>
    </template>
    <el-table :data="tableData" style="width: 100%" border stripe>
      <el-table-column prop="dormitoryName" label="楼栋" width="200" align="center" />
      <el-table-column prop="roomName" label="宿舍号" width="130" align="center" />
      <el-table-column prop="dormitoryBedNo" label="床位号" width="80" align="center" />
      <el-table-column label="所属人类型" width="120" align="center">
        <template v-slot="{row}">
          {{ row.userType ? $store.state.systemParam.userTypeMap[row.userType].label : '' }}
        </template>
      </el-table-column>
      <el-table-column label="床位所属人" width="160">
        <template v-slot="{ row }">
          {{ row.userType == 2 ? row.stuName : row.realName }}
        </template>
      </el-table-column>
      <el-table-column label="学号/工号" width="160">
        <template v-slot="{ row }">
          {{ row.userType == 2 ? row.stuNo : row.username }}
        </template>
      </el-table-column>
      <el-table-column prop="executeRealName" label="操作员" width="120" align="center" />
      <el-table-column prop="createTime" label="操作时间" width="160" align="center" />
      <el-table-column prop="remarks" label="备忘" min-width="200" />
    </el-table>
  </table-view>
</template>

<script>
import tableView from '@/vue/mixins/table-view'
import { pageBedClearRecordApi } from '@/api/dorm/bed-clear-record-api'

export default {
  name: 'BedClearRecord',
  mixins: [tableView],
  data() {
    return {
      buildList: [], // 楼栋
      floorList: 0, // 楼层
      roomList: [], // 宿舍
      queryInfo: {
        dormitoryId: null,
        floorNum: null,
        roomId: null,
        userId: null
      }
    }
  },
  async mounted() {
    this.isAdmin = this.$store.state.login.userInfo.paraNameList.includes('psycho:app')
    await Promise.all([
      this.getDormBuild()
    ])
    // await this.renderTable(1)
  },
  methods: {
    async renderTable(pageNum) {
      const _userInfo = this.$store.state.login.userInfo
      this.queryInfo.userId = this.isAdmin ? this.queryInfo.userId : _userInfo.id
      await this.getTableData(pageBedClearRecordApi, pageNum)
    },
    // 获取宿舍列表
    getDormRoomList() {
      this.clearList(this.roomList)
      this.queryInfo.roomId = null
      this.$http
        .getDormRoomQuery({
          dormitoryId: this.queryInfo.dormitoryId,
          floorNum: this.queryInfo.floorNum
        })
        .then((res) => {
          this.roomList = res.data
          this.renderTable(1)
        })
    },
    // 生成楼层
    createFloor(id) {
      if (id) {
        this.floorList = this.buildList.find((item) => item.id === id).floorAmount
      }
    },
    // 获取楼栋
    async getDormBuild() {
      // 1 获取宿舍楼list
      try {
        const res = await this.$http.listDormitoryApi({})
        this.buildList = res.data
      } catch (e) {
        console.error(e)
      }
    },
    // 根据选择的宿舍楼，选择新的楼层list
    changeBuild(id) {
      this.clearList(this.roomList)
      this.clearList(this.floorList)
      this.queryInfo.floorNum = null
      this.queryInfo.roomId = null
      if (id) {
        this.createFloor(id)
      } else {
        this.queryInfo.dormitoryId = null
      }
      this.renderTable(1)
    }
  }
}
</script>
